import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Footer from "@/components/Footer";

export default function Landing() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const t = setTimeout(() => {
        window.__lenis?.scrollTo(location.state.scrollTo, { offset: -72 });
      }, 300);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <main className="bg-obsidian">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <Services />
      <Gallery />
      <Footer />
    </main>
  );
}
